export default __webpack_public_path__ + "static/media/redleaf.bd9ac8d2.jpg";